<template>
    <div id="step-2" class="step step-2" :class="{active: activeStep == 2}">
        <div class="line"></div>
        <div class="number">{{ step }}</div>
        <div class="title">{{ title }}</div>
        <mu-paper class="content" :z-depth="1">
            <mu-row justify-content="center" align-items="center" class="item">
                <mu-col span="8" sm="8" md="8" lg="8" xl="8" class="description">
                    <h3>Importar contatos</h3>
                    Selecione seu arquivo CSV que contenha as variáveis.
                </mu-col>
                <mu-col span="3" sm="3" md="3" lg="3" xl="3" class="total-contacts">
                    <span>{{ form.totalcontacts }}</span>
                    Contato(s)
                </mu-col>
                <mu-col span="1" sm="1" md="1" lg="1" xl="1" class="more-options">
                    <div class="upload" v-if="file == ''">
                        <input type="file" ref="file" @change="uploadFile">
                        <font-awesome-icon icon="plus" />
                    </div>
                    <div class="upload" v-else>
                        <a href="javascript:;" @click="removeFile()">
                            <font-awesome-icon icon="trash" />
                        </a>
                    </div>
                </mu-col>
            </mu-row>
            <mu-row justify-content="center" align-items="center" class="summary">
                <mu-col span="1" sm="1" md="1" lg="1" xl="1" class="description">
                    <font-awesome-icon icon="info-circle" size="3x" />
                </mu-col>
                <mu-col span="11" sm="11" md="11" lg="11" xl="11">
                    <ul>
                        <li v-if="file">O arquivo <strong>{{ file.name }}</strong> possui o tamanho de <strong>{{ file.size }}</strong> kbytes <a href="javascript:;" @click="removeFile()">Remover arquivo e contatos</a></li>
                        <li>Você pode informar o mesmo número mais de uma vez.</li>
                        <li>Somente 1 lista pode ser enviada. Se for enviado outra ela substituirá a antiga.</li>
                        <li><span class="btn-dialog-variable" @click="openVariableDialog()">Veja como montar seu arquivo CSV.</span></li>
                    </ul>
                </mu-col>
            </mu-row>

            <mu-dialog title="Modelo de envio com variáveis" :open.sync="openDialog" class="dialog-variable">
                <p>O arquivo deve ser do tipo .CSV, não ter cabeçalho e possuir a seguinte estrutura:</p>

                <img src="/img/example-variable.png" width="100%">

                <mu-button slot="actions" flat color="primary" @click="closeVariableDialog">Fechar</mu-button>
            </mu-dialog>

        </mu-paper>
        <mu-paper class="buttons" :z-depth="1">
            <mu-flex justify-content="center" align-items="center">
                <mu-button color="#EEF1F3" textColor="#666" round @click="handlePrev()">
                    <font-awesome-icon icon="chevron-left" class="icon-md icon-margin-left"/>
                    Voltar
                </mu-button>
                <mu-button round @click="validateContacts()" color="primary">
                    Próximo
                    <font-awesome-icon icon="chevron-right" class="icon-md icon-margin-right"/>
                </mu-button>
            </mu-flex>
        </mu-paper>
    </div>
</template>

<script>
    import ImportsServices from '@/services/contacts/import'

    export default {
        name: 'campaign-step-contacts-vars',
        props: ['activeStep', 'step', 'title', 'form'],

        // ╔╦╗╔═╗╔╦╗╔═╗
        //  ║║╠═╣ ║ ╠═╣
        // ═╩╝╩ ╩ ╩ ╩ ╩

        data () {
            return {
                file: '',
                uuid: null,
                totalValid: 0,
                totalInvalid: 0,
                openDialog: false
            }
        },

        // ╔╦╗╔═╗╔╦╗╦ ╦╔═╗╔╦╗╔═╗
        // ║║║║╣  ║ ╠═╣║ ║ ║║╚═╗
        // ╩ ╩╚═╝ ╩ ╩ ╩╚═╝═╩╝╚═╝

        methods: {

            openVariableDialog () {
                this.openDialog = true
            },

            closeVariableDialog () {
                this.openDialog = false
            },

            /**
             * Chama o evento handlePrev do elemento pai
             */
            handlePrev () {
                this.$emit('handlePrev')
            },

            /**
             * Chamando o emit para dar sequência no cadastro
             */
            handleNext () {
                this.$emit('handleNext', this.form)
            },

            async uploadFile (e) {
                try {
                    this.file = this.$refs.file.files[0]
                    let extension = this.file.name.split('.').pop()
                    let extensionsPossibles = ['CSV']
                    if (!extensionsPossibles.includes(extension.toUpperCase())) {
                        this.$eventHub.$emit('snackbar', 'error', `A extensão do arquivo não é permitido (.${extension.toUpperCase()}).`)
                        this.file = ''
                        return
                    }
                    this.$eventHub.$emit('loading', true, 'Aguarde... Estamos importando sua lista de contatos e variáveis.')
                    let data = { file: this.file }
                    if (this.form.for_client) {
                        data.id_companies = this.form.client_id
                    }
                    let result = await ImportsServices.storeVars(data)
                    if (result && result.status) {
                        let data = result.results
                        this.totalValid = data.totalValid
                        this.totalInvalid = data.totalInvalid
                        this.form.totalcontacts = this.totalValid
                        this.form.groups = [{ id: data.uuid, name: 'Grupo com variáveis' }]
                        this.$eventHub.$emit('snackbar', 'success', result.message || `Sucesso na importação.`)
                    }
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', `Ocorreu um erro na importação de arquivo. (${e.message})`)
                } finally {
                    this.$eventHub.$emit('loading', false)
                }
            },

            removeFile () {
                this.file = ''
                this.form.totalcontacts = 0
                this.totalValid = 0
                this.totalInvalid = 0
                this.uuid = null
                this.form.groups = []
            },

            validateContacts () {
                if (this.totalValid > 0 && this.form.groups.length > 0) {
                    this.handleNext()
                } else {
                    this.$eventHub.$emit('snackbar', 'error', 'Não foi possível validar os contatos. Verifique se foi importado os contatos.')
                }
            }
        }
    }
</script>

<style lang="stylus" scoped>

    @import './../../../assets/stylus/bootstrap.styl'

    .step-2

        .content
            padding 0

            .row
                border-bottom 1px #e0e0e0 solid

                .description
                    padding 14px 20px
                    line-height 20px
                    color #9fa9ae
                    h3
                        color $primary
                        margin 0
                        padding 0

                .total-contacts
                    background #fafbfb
                    text-align center
                    font-size 10px
                    text-transform uppercase
                    color #9fa9ae
                    padding 20px 0
                    span
                        line-height 22px
                        font-size 22px
                        font-weight bold
                        display block

                .more-options
                    background #f5f6f7
                    text-align center
                    color #9fa9ae
                    svg
                        margin 28px 0 20px 0
                        font-size 20px

            .summary
                background #f5f6f7
                padding 10px 0px

                a
                    text-decoration underline
                    color $primary

            .upload
                width 100%
                color darken($grey, 30%)
                text-align center
                position relative
                overflow hidden
                display inline-block
                a
                    color darken($grey, 30%)

                input[type='file']
                    border 0
                    width 100%
                    z-index 200
                    cursor pointer
                    position absolute
                    left 0
                    top 0
                    bottom 0
                    opacity 0

            .btn-dialog-variable
                color $primary
                text-decoration underline
                cursor pointer
                font-size 14px

    ul.dialog-list
        background #f5f6f7
        padding 20px
        margin 20px 0
        li
            margin-left 20px
            p
                margin 0
                color #757575
                font-size 13px
                line-height 1.5
</style>
